import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { Instagram, Twitter } from "lucide-react";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black mt-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-gothic text-5xl text-blood leading-none">Beaudoin</div>
          <p className="mt-6 max-w-sm text-white/60 leading-relaxed">
            Gothic luxury born in Saint Barthélemy. Limited series, no restock.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-6">{t.footer.newsletter}</div>
          <form
            data-testid="newsletter-form"
            onSubmit={(e) => { e.preventDefault(); e.target.reset(); alert("Subscribed."); }}
            className="flex border-b border-white/30 focus-within:border-white transition-colors"
          >
            <input
              data-testid="newsletter-email"
              type="email"
              required
              placeholder={t.footer.placeholder}
              className="flex-1 bg-transparent text-sm py-3 outline-none placeholder:text-white/30"
            />
            <button data-testid="newsletter-submit" type="submit" className="text-xs font-bold tracking-[0.2em] uppercase">
              →
            </button>
          </form>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-6">Navigate</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/shop" className="hover:text-white/70 transition-colors">{t.nav.shop}</Link></li>
            <li><Link to="/collections" className="hover:text-white/70 transition-colors">{t.nav.collections}</Link></li>
            <li><Link to="/about" className="hover:text-white/70 transition-colors">{t.nav.about}</Link></li>
            <li><Link to="/contact" className="hover:text-white/70 transition-colors">{t.nav.contact}</Link></li>
            <li><Link to="/admin" className="hover:text-white/70 transition-colors text-white/30">{t.nav.admin}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-6">Atelier</div>
          <p className="text-sm text-white/60">Gustavia<br/>Saint Barthélemy<br/>97133, F.W.I.</p>
          <div className="flex gap-4 mt-6">
            <a href="#" className="hover:text-white/70 transition-colors"><Instagram className="w-5 h-5" /></a>
            <a href="#" className="hover:text-white/70 transition-colors"><Twitter className="w-5 h-5" /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-6 text-xs text-white/40 text-center">
        © 2026 BAUDOIN — {t.footer.rights}
      </div>
    </footer>
  );
}
